import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import TicketCorporateCreditDeleteButton from './TicketCorporateCreditDeleteButton';
import TicketCorporateCreditUnifyInvoicesButton from './TicketCorporateCreditUnifyInvoicesButton';
import TicketCorporateCreditAddCreditLineButton from './TicketCorporateCreditAddCreditLineButton';

const TicketCorporateCreditToolBar = ({
  ticketCorporateCreditId,
  companyId,
}) => (
  <ButtonToolbar className="pull-right">
    <div>
      <TicketCorporateCreditUnifyInvoicesButton
        ticketCorporateCreditId={ticketCorporateCreditId}
        companyId={companyId}
      />{' '}
      <TicketCorporateCreditAddCreditLineButton
        ticketCorporateCreditId={ticketCorporateCreditId}
      />{' '}
      <TicketCorporateCreditDeleteButton
        ticketCorporateCreditId={ticketCorporateCreditId}
      />{' '}
    </div>
  </ButtonToolbar>
);

TicketCorporateCreditToolBar.propTypes = {
  ticketCorporateCreditId: PropTypes.number.isRequired,
  companyId: PropTypes.number,
};

TicketCorporateCreditToolBar.defaultProps = {
  companyId: null,
};

export default TicketCorporateCreditToolBar;
